module.exports = __webpack_public_path__ + "img/jiaoyu.4b0bd646.png";